module.exports = __webpack_public_path__ + "media/images/stanford_on_broadway/Dec18_Broadway_Kathy_CR-p-800-5a2b061ae3e6f4a472859a4d4d90b70a.jpg";